import {
    useEffect,
    useRef,
    useState
} from 'react';
import {
    Container,
    Content,
    AvatarWrapper,
    Body,
    Input,
    Actions,
    MessageAlert,
    LoadingProgress
} from './styled';
import {
    Avatar,
    Alert,
    Switch,
    Modal,
    ViewerCustomerServiceOpen
} from '../../components';
import { useChat } from '../../contexts/chat';
import { PhoneCompany } from '../../contexts/auth';
import { maskPhone } from '../../utils';
import {
    getAccessibilityByPhone,
    postAccessibilityByPhone
} from '../../service/serviceChat/chatService';
import {
    deleteClient
} from '../../service/serviceChat/clientsService';
import {
    qtdCustomerServiceOpen
} from '../../service/serviceChat/customerService';
import { IoIosClose } from 'react-icons/io';
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { toast } from 'react-toastify';
import LoadDelete from '../../assets/gif/yZ8lvCADrz.gif';
import LoadUpdate from '../../assets/gif/Mz9UGRlMjA.gif';

export function ContactProfile(props) {

    const {
        name,
        contact,
        onBack,
        onLoad
    } = props;
    const {
        UpdateNameClient,
        functionality,
        accessLevel,
        reload
    } = useChat();

    const refInputName = useRef(null);

    const [audioOnly, setAudioOnly] = useState(false);
    const [audioOnlyIsEnabled, setAudioOnlyIsEnabled] = useState(false);
    const [nameContact, setNameContact] = useState(name ? name : contact.name);
    const [switchState, setSwitchState] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allowEditing, setAllowEditing] = useState(false);
    const [renderAlert, setRenderAlert] = useState(false);
    const [existCustomerServiceOpen, setExistCustomerServiceOpen] = useState(null);

    const searchAccessibility = async () => {
        if (functionality.includes('somente_audio')) {
            setAudioOnly(true)
            const accessibility = await getAccessibilityByPhone(
                contact?.number_client
            );
            if (accessibility.length >= 1) {
                setSwitchState(true);
                setAudioOnlyIsEnabled(true);
            } else {
                setAudioOnlyIsEnabled(false);
            }
        }
    };
    useEffect(() => {
        searchAccessibility();
    }, []);

    useEffect(() => {
        if (allowEditing && refInputName.current) {
            refInputName.current.focus();
        }
    }, [allowEditing]);


    const onWaitingTime = (callback) => {
        const timeoutId = setTimeout(() => {
            callback();
        }, 2000);
        return () => clearTimeout(timeoutId);
    };
    function handReset() {
        searchAccessibility();
        setNameContact(contact?.name);
        setAllowEditing(false);
    };
    async function handSave() {
        setLoading(true);
        if (!nameContact.trimStart()) {
            toast.warn(
                'Informe um nome para o contato !',
                { position: "top-center", theme: "colored" }
            );
        } else {
            const isNameUpdated = await UpdateNameClient(
                nameContact.trimStart(),
                contact?.number_client,
                PhoneCompany()
            )
            if (!isNameUpdated) {
                toast.error(
                    `Erro ao atualizar o nome`,
                    { position: "top-center", theme: "colored" }
                );
            };
            let isAccessibilityUpdated = true;
            if (
                (audioOnlyIsEnabled && !switchState)
                || (!audioOnlyIsEnabled && switchState)
            ) {
                isAccessibilityUpdated = await postAccessibilityByPhone(
                    contact?.number_client,
                    1
                );
                if (!isAccessibilityUpdated) {
                    toast.error(
                        `Erro ao atualizar acessibilidade`,
                        { position: "top-center", theme: "colored" }
                    );
                };
            };
            if (isNameUpdated && isAccessibilityUpdated) {
                reload();
                onWaitingTime(
                    () => {
                        onLoad();
                        setLoading(false);
                        setAllowEditing(false);
                        toast.success(
                            `Contato Atualizado !`,
                            { position: "top-center", theme: "colored" }
                        );
                    }
                )
                return
            };
        }
        setLoading(false);
    };

    async function onExistCustomerServiceOpen(id) {
        const customerServiceOpen = await qtdCustomerServiceOpen(id, true);
        if (!customerServiceOpen || customerServiceOpen?.length === 0) {
            return false;
        } else {
            toast.warn(
                (<div>
                    <p>
                        {`Existe atendimento em aberto ! `}
                    </p>
                    <u
                        onClick={
                            () => setExistCustomerServiceOpen(customerServiceOpen)
                        }
                    >
                        {`Ver Atendimento`}
                    </u>
                </div>),
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return true;
        }
    };

    async function handDelete() {
        const exist = await onExistCustomerServiceOpen(contact?.id)
        if (!exist) {
            setRenderAlert(true);
        }
        return
    };
    async function onDeleteContact() {
        setRenderAlert(false);
        setLoading(true);
        const isDeleted = await deleteClient(contact?.number_client);
        if (isDeleted) {
            reload();
            onWaitingTime(
                () => {
                    onLoad();
                    setLoading(false);
                    onBack();
                    toast.success(
                        `Contato apagado !`,
                        { position: "top-center", theme: "colored" }
                    );
                }
            )
            return
        } else {
            toast.error(
                `Erro ao deletar contato`,
                { position: "top-center", theme: "colored" }
            );
            setLoading(false);
        };
        setLoading(false);
    };

    return (
        <>
            <Container isLoading={loading ? 1 : 0}>
                <Content>
                    <div className='xtR'>
                        <AvatarWrapper>
                            <div>
                                <Avatar
                                    name={nameContact}
                                    width={'100%'}
                                    height={'100%'}
                                    fontSize={'2.5rem'}
                                />
                            </div>
                            <span onClick={() => onBack()}>
                                <IoIosClose fontSize={`2.5rem`} />
                            </span>
                            <span>
                                {maskPhone(
                                    contact?.number_client
                                )}
                            </span>
                        </AvatarWrapper>
                    </div>
                    <Body>
                        <div>
                            <Input
                                ref={refInputName}
                                id='nameContact'
                                name='nameContact'
                                value={nameContact}
                                disabled={!allowEditing}
                                onChange={(e) => setNameContact(e.target.value)}
                                placeholder='Nome Completo'
                            />
                        </div>
                        <div>
                            {audioOnly &&
                                (<Switch
                                    label={`Enviar somente audio`}
                                    disabled={!allowEditing}
                                    checked={switchState}
                                    onChange={() => setSwitchState(!switchState)}
                                />)
                            }
                        </div>
                    </Body>
                    {!allowEditing
                        ? (
                            <Actions>
                                <button
                                    className="btn--edit"
                                    onClick={() => setAllowEditing(true)}
                                >
                                    <span>
                                        <FiEdit fontSize={`1.5rem`} />
                                    </span>
                                    {`Alterar`}
                                </button>

                                {accessLevel?.includes('APAGAR_CONTATO') &&
                                    (<button
                                        className="btn--delete-cancel"
                                        onClick={() => handDelete()}
                                    >
                                        <span>
                                            <MdDelete fontSize={`1.5rem`} />
                                        </span>
                                        {`Apagar`}
                                    </button>)
                                }
                            </Actions>
                        )

                        : (<Actions>
                            <button
                                className="btn--delete-cancel"
                                onClick={() => handReset()}
                            >
                                {`Cancelar`}
                            </button>
                            <button
                                className="btn--save"
                                onClick={() => handSave()}
                            >
                                <span>
                                    <FaCheck fontSize={`1.5rem`} />
                                </span>
                                {`Salvar`}
                            </button>
                        </Actions>)
                    }
                </Content>
            </Container>
            <Alert
                isOpen={renderAlert ? 1 : 0}
                title={`Apagar Contato !`}
                onClickOption1={
                    () => onDeleteContact()
                }
                onClickOption2={
                    () => setRenderAlert(false)
                }
            >
                <MessageAlert>
                    <p>
                        {`Ao apagar o contato `}
                        <span>
                            {maskPhone(contact?.number_client)}
                        </span>
                        {`
                                todo o seu histórico de conversas e 
                                atendimento serão perdidos. 
                                Não será possível recuperar !
                            `}
                    </p>
                    <p>
                        {`
                                Deseja prosseguir ?
                            ` }
                    </p>
                </MessageAlert>
            </Alert>
            <LoadingProgress isOpen={loading ? 1 : 0}>
                <div>
                    <img
                        src={allowEditing ? LoadUpdate : LoadDelete}
                        alt="load--"
                    />
                    <p>
                        {allowEditing
                            ? `Atualizando contato ...`
                            : `Apagando contato ...`
                        }
                    </p>
                </div>
            </LoadingProgress>
            <Modal title={'Atendimento em aberto'}
                isOpen={existCustomerServiceOpen ? true : false}
                close={
                    () => setExistCustomerServiceOpen(null)
                }
            >
                <ViewerCustomerServiceOpen
                    customerServiceOpen={existCustomerServiceOpen}
                    onClose={
                        () => setExistCustomerServiceOpen(null)
                    }
                />
            </Modal>
        </>
    );
}